import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (isDismissed) return;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      // Calculate scroll percentage
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      // Show banner when scrolled past 70%
      if (scrollPercentage > 0.7 && !isVisible) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Check initially in case the page is already scrolled
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed, isVisible]);
  return <AnimatePresence data-id="element-190">
      {isVisible && !isDismissed && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:w-[380px] bg-white border border-gray-200 shadow-2xl z-50 p-6 flex flex-col gap-4" data-id="element-191">
          <button onClick={() => setIsDismissed(true)} className="absolute top-4 right-4 text-gray-400 hover:text-dark transition-colors" aria-label="Закрити" data-id="element-192">
            <X size={16} data-id="element-193" />
          </button>

          <p className="text-sm text-dark font-light leading-relaxed pr-6" data-id="element-194">
            Створюємо сучасні сайти{' '}
            <span className="font-medium" data-id="element-195">БЕЗКОШТОВНО</span>, обслуговування
            всього 650 грн / місяць.
          </p>

          <div className="flex flex-col gap-3 mt-2 pt-4 border-t border-gray-100" data-id="element-196">
            <a href="https://jetly.agency/ua/sale" target="_blank" rel="noreferrer" className="text-xs font-medium tracking-widest uppercase text-accent hover:text-dark transition-colors" data-id="element-197">
              Дізнатися більше
            </a>
            <a href="tel:+380502276199" className="text-xs font-medium tracking-widest uppercase text-dark hover:text-accent transition-colors" data-id="element-198">
              +38 050 227 61 99
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}